import React, { useState } from "react";
import { Lock, FileDown, Unlock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { openAuthedPdf } from "../../lib/pdf";

/* 只读归档的项目群：替代输入框 —— 说明 + 导出全文纪要 PDF + 群主 / 管理员「重新开放」 */
export const FrozenBar = ({ ch, api, zh, canReopen, onReopened }) => {
  const T = (z, e) => (zh ? z : e);
  const [busy, setBusy] = useState("");
  const exportPdf = async () => {
    setBusy("export");
    try { await openAuthedPdf(api, `/chat/channels/${ch.id}/export.pdf?lang=${zh ? "zh" : "en"}`, `Minutes_${(ch.name || ch.id).replace(/\s+/g, "_")}.pdf`); toast.success(T("纪要 PDF 已生成", "Minutes PDF ready")); }
    catch (e) { toast.error(e?.response?.data?.detail || e.message); }
    setBusy("");
  };
  const reopen = async () => {
    setBusy("reopen");
    try { await api.post(`/chat/channels/${ch.id}/reopen`); toast.success(T("已重新开放，可继续发言", "Reopened")); onReopened?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || e.message); }
    setBusy("");
  };
  return (
    <div data-testid="chat-frozen-bar" className="border-t border-amber-200 bg-amber-50 px-3 sm:px-4 py-2.5 flex flex-wrap items-center gap-2 text-[12px] text-amber-800">
      <Lock className="h-4 w-4 shrink-0" />
      <span className="flex-1 min-w-[200px]">{T("项目完工满 30 天，本群已归档为只读：成员仍可查看 / 搜索，不能再发消息。", "Project completed 30+ days ago — this group is read-only: members can still read / search, no new messages.")}</span>
      <button type="button" data-testid="chat-frozen-export" disabled={!!busy} onClick={exportPdf} className="inline-flex items-center gap-1 rounded-full bg-white border border-amber-300 px-3 py-1 font-semibold hover:bg-amber-100 disabled:opacity-50">{busy === "export" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileDown className="h-3.5 w-3.5" />}{T("导出全文纪要 PDF", "Export minutes PDF")}</button>
      {canReopen && <button type="button" data-testid="chat-frozen-reopen" disabled={!!busy} onClick={reopen} className="inline-flex items-center gap-1 rounded-full bg-amber-600 text-white px-3 py-1 font-semibold hover:bg-amber-700 disabled:opacity-50">{busy === "reopen" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Unlock className="h-3.5 w-3.5" />}{T("重新开放", "Reopen")}</button>}
    </div>
  );
};
